import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const TextShadowOpacityListItem = (props) => {
    const { shadowSettingsOpacity, updateTextElement, index, maxDropShadowOpacity } = props;

    const onShadowOpacityChange = (value) => {
        previewHistoryBatch.start();

        updateTextElement(index, {
            shadowSettings: { opacity: value }
        });
    };

    return (
        <SliderListItem
            title='Opacity'
            value={shadowSettingsOpacity}
            displayMultiplier={100}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowOpacityChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const shadowSettingsOpacity = element && element.shadowSettings ? element.shadowSettings.opacity : 0;
    const { maxDropShadowOpacity } = state.create.maxValues;

    return {
        shadowSettingsOpacity,
        maxDropShadowOpacity
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextShadowOpacityListItem);
